import * as React from 'react';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgAngleLeftGray = function SvgAngleLeftGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.554,
    height: 13.125
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.407 11.183 9.849 5.635a.983.983 0 0 0-1.394 1.384l4.861 4.91-4.861 4.861a.983.983 0 1 0 1.394 1.385l5.558-5.548a.982.982 0 0 0 0-1.444Z",
    transform: "translate(-8.169 -5.344)",
    style: {
      fill: "#80868b",
      opacity: 1
    }
  }));
};

export { SvgAngleLeftGray as ReactComponent };
//# sourceMappingURL=AngleLeftGray.svg.js.map
